'use client';

import { c as _c } from "react/compiler-runtime";
import { addDays } from 'date-fns';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { getCookieDomain } from '@/lib/analytics/lok-aid';
import { CLICK_ID_PARAMS } from '@/lib/constants';
declare global {
  interface Window {
    OnetrustActiveGroups: string;
  }
}

// const PERFORMANCE_AND_TARGETING_COOKIES_ID = 'C0007'

export function ClickIdTracker() {
  const $ = _c(3);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = () => {
      const setClickIdCookies = function setClickIdCookies() {
        for (const param of CLICK_ID_PARAMS) {
          const value = searchParams.get(param);
          if (!value) {
            continue;
          }
          const expiry = addDays(new Date(), 14).toUTCString();
          const domain = getCookieDomain();
          const domainAttr = domain ? `; domain=${domain}` : "";
          const cookie = `${param}=${encodeURIComponent(value)}${domainAttr}; expires=${expiry}; path=/; SameSite=Lax; Secure`;
          ;
          try {
            document.cookie = cookie;
          } catch (t1) {
            const error = t1;
            console.error("Failed to set cookie:", error);
          }
        }
      };
      setClickIdCookies();
    };
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}